module.exports = __webpack_public_path__ + "img/191cd28.png";